<template>
  <div class="">
    <login-after-head-search></login-after-head-search>
    <div class="container pb36">
      <div class="pay-title ">
        <a target="_self" href="#">首页</a><span class="arrow"></span>去结算
      </div>
      <div class="address-manage">
        <div class="home-allTitle award-title-cg">
          <span>选择收货地址</span>
          <p class="add-address">
            <router-link to="address">
              <a href="">管理收货地址</a>
            </router-link>
          </p>
        </div>
        <div class="address-bgs">
          <div class="address-bg fc-bet" @click.stop="addressIndex=index" :class="addressIndex==index?'active':''"
               v-for="(item,index) in addressList" :key="index">
            <div class="address-box">
              <span class="address-text ">{{ item.realName }}</span>
              <span class="">{{ item.phone }}</span>
              <p class="">{{ item.province + item.city + item.district + item.detail }}</p>
            </div>
          </div>
        </div>
        <div class="home-allTitle award-title-cg">
          <span>确认订单信息</span>
        </div>
      </div>
      <div id="cart-main">
        <div class="tool-bar">
          <div class="row f14 flex" style="overflow: hidden!important;">
            <div class="cell c21 w90 ">序号</div>
            <div class="cell c2 text-center">商品</div>
            <!--<div class="cell c22">箱装数</div>-->
            <!--<div class="cell c23">盒装数</div>-->
            <div class="cell c3">含税面价</div>
            <div class="cell c3">数量</div>
            <div class="cell c5">合计</div>
            <div class="cell c3">折扣系数</div>
            <div class="cell c3">折扣金额</div>
            <div class="cell c55">总额</div>
          </div>
        </div>
        <div class="goods">
          <div class="row myRow flex" v-for="(item,index) in orderInfo.cartInfo" :key="index">
            <div class="cell c21">{{ index + 1 }}</div>
            <div class="cell c1">
              <router-link :to="{path:'details',query:{unique:item.productInfo.attrInfo.unique}}">
                <img :src="item.productInfo.attrInfo.image" v-if="item.productInfo.attrInfo.image" alt=""  style="width: 80px;height: 80px">
                <img :src="item.productInfo.image" v-else-if="item.productInfo.image" alt=""  style="width: 80px;height: 80px">
                <img src="../assets/noll.png" v-else style="width: 80px;height: 80px"/>
              </router-link>
            </div>
            <div class="cell c2">
              <div class="pname">
                <router-link :to="{path:'details',query:{unique:item.productInfo.attrInfo.unique}}">
                  {{ item.productInfo.storeName }}
                </router-link>
                <span class="productCode ">{{ item.productInfo.attrInfo.skuName }}</span>
              </div>
            </div>
            <!--<div class="cell c22 ">90</div>-->
            <!--<div class="cell c23 ">6</div>-->
            <div class="cell c3 ">{{ item.vipTruePrice }}</div>
            <div class="cell c3">{{ item.cartNum }}</div>
            <div class="cell c3"><span>{{ (item.vipTruePrice * item.cartNum).toFixed(2) }}</span></div>
            <div class="cell c3">{{ item.discount }}</div>
            <div class="cell c3">{{ (item.discountPrice * item.cartNum ).toFixed(2) }}</div>
            <div class="cell c55"><span class="f23030 ">￥{{ (item.truePrice * item.cartNum).toFixed(2) }}</span></div>
          </div>
        </div>
      </div>
      <div id="cart-bar" class="cart-bar-fixed">
        <ul class="goslmt">
          <li class="cart-totle">数量总计：<span class="f23030">{{ totalNum }}个</span></li>
          <li class="cart-totle">
            面价金额：<span class="f23030 font-price ">￥{{ computedPriceInfo.costPrice }}</span>
            <div>
              折后金额: <span class="f23030 font-price ">￥{{ computedPriceInfo.totalPrice }}</span>
            </div>
            <div>
              已节省：<span class="">-￥{{ computedPriceInfo.totalDiscountPrice }}</span>
            </div>
            <div>
              (若折扣率>0.4，积分按*0.35折算) 折扣率：<span class="">{{(computedPriceInfo.payPrice/computedPriceInfo.costPrice).toFixed(2)}}</span>
            </div>
            <div>
              奖励积分：<span class="">{{ parseInt(computedPriceInfo.gainIntegral) }}积分</span>
            </div>
            <div>
              优惠券金额：<span class="">-￥{{ computedPriceInfo.couponPrice }}</span>
            </div>
            <div>
              应付金额: <span class="f23030 font-price ">￥{{ computedPriceInfo.payPrice }}</span>
            </div>
            <!--					                    <div>-->
            <!--					                        积分消耗合计: <span class="f23030 font-price ">0   积分</span>-->
            <!--					                    </div>-->
          </li>

          <li><a :loading="btnLoading" @click.once="submit" class="btn f18">提交订单</a></li>

        </ul>
        <div class="orderExtLeft fl">
          <div class="row fc">
            <div class="tit">
              店铺优惠：
            </div>
            <div>
              <el-select v-model="couponId" placeholder="请选择" @change="chooseCoupon" style="width: 320px">
                <el-option
                    v-for="(coupon,index) in couponsList.valid"
                    :key="coupon.id"
                    :label="coupon.promotionName"
                    :value="coupon.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <!--					<div class="row fc">-->
          <!--						<div class="tit">-->
          <!--							积分支付：-->
          <!--						</div>-->
          <!--						<div>-->
          <!--							<input type="text" placeholder="输入使用的积分">-->
          <!--							<a href="">全部积分</a>-->
          <!--							<span>1200,00</span>-->
          <!--						</div>-->
          <!--					</div>-->
          <div class="row flex">
            <div class="tit">
              留言备注：
            </div>
            <div>
              <textarea v-model="mark" id="" cols="30" rows="10" placeholder="请输入订单备注" style="width: 320px"></textarea>
            </div>
          </div>
        </div>
        <div class="clear clearfix"></div>
      </div>
    </div>

    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import {
  confirmOrder,
  getStoreList,
  computedOrder,
  createOrder
} from '@/api/order'
import {
  getCityData,
  getAddressData,
  setDefaultAddress
} from '@/api/user'

import {
  getCouponByCart
} from "@/api/ec/coupons.js";
	export default {

		data() {
			return {
        loading: false,
        activeMethod: 1,
        storeList: [],
        amount: 0,
        defaultAddress: {'realName': ''},
        defaultStore: {},
        couponsList: {
          valid: [{
            promotionName: '请选择优惠券',
            id: 0
          }],
          invalid: []
        },
        couponId:0,
        storeIndex: {
          index: null
        },
        contact: {
          receiver: '',
          phoneNumber: ''
        },
        addressList: [],
        newAddress: {
          real_name: null,
          phone: null,
          address: {
            city: null,
            cityId: null,
            district: null,
            province: null
          },
          id: null,
          detail: null,
          is_default: false
        },
        mark: '',
        addressIndex: 0,
        options: [],
        value: {
          label: []
        },
        couponList: [],
        curCoupon: {
          id: null,
          money: null
        },
        btnLoading: false,
        addVisible: false,
        switchVisible: false,
        mapVisible: false,
        totalNum:0,
        orderInfo: {
          addressInfo: {},
          cartInfo: [],
          combinationId: null,
          deduction: false,
          enableIntegral: true,
          enableIntegralNum: 0,
          integralRatio: null,
          orderKey: null,
          priceGroup: null,
          storeSelfMention: null,
          systemStore: null,
          usableCoupon: null,
          userInfo: null
        },
        computedPriceInfo: {
          couponPrice: "0.00",
          deductionPrice: "0.00",
          payIntegral: "0.00",
          payPostage: "0.00",
          payPrice: "0.00",
          totalPrice: "0.00",
          usedIntegral: 0,
          lastCardPrice: '0.00',
          totalDiscountPrice: '0.00',
          costPrice: '0.00'
        },
			}
		},
		mounted() {
      this.loading = true
      let cartId=this.$route.query.cartId
      this.cartId=cartId
      Promise.all([this.getAddressList(), this.getCityList()])
          .then(this.postOrderConfirm(cartId))
		},
		methods: {
      // 获取结算详情
      // getSettlement () {
      //   let cartId=this.$route.query.cartId
      //   var data = {
      //     cartId: cartId
      //   }
      //   confirmOrder(data).then(res => {
      //     if (res.status === 200) {
      //
      //       this.defaultAddress = res.data.addressInfo
      //       this.defaultStore = res.data.systemStore
      //       if (this.defaultAddress === null) {
      //         this.defaultAddress = this.addressList[0]
      //       }
      //       this.computedAmount()
      //     } else {
      //       this.$message.warning(res.msg)
      //     }
      //   })
      // },
      // 计算订单金额
      // computedAmount () {
      //
      //   computedOrder(this.settlementData.orderKey, {
      //     addressId: this.defaultAddress.id,
      //     bargainId: '',
      //     combinationId: '',
      //     couponId: '',
      //     payType: 1,
      //     pinkId: '',
      //     shipping_type: this.activeMethod,
      //     useIntegral: ''
      //   }).then(res => {
      //     if (res.status === 200) {
      //       this.orderPrice = res.data.result
      //       this.orderPrice.webPrice = this.orderPrice.payPrice
      //       this.loading = false
      //     } else {
      //       this.$message.warning(res.msg)
      //     }
      //   })
      // },
      // 获取地址列表
      async getAddressList () {
        var res = await getAddressData()
        if (res.data.length === 0) {
          this.$message.warning('您当前没有任何地址，请添加一个地址！')
          this.$router.push({path: '/address'})
          // this.addVisible = true
        }
        if (res.status === 200) {
          this.addressList = res.data
          this.addressList.forEach((i,index) => {
            if(i.isDefault){
              this.addressIndex=index;
            }
          })
        } else {
          this.$message.warning(res.msg)
        }
      },
      // 获取城市列表
      async getCityList () {
        var res = await getCityData()
        if (res.status === 200) {
          const json1 = JSON.parse(JSON.stringify(res.data).replace(/v/g, 'value'))
          const json2 = JSON.parse(JSON.stringify(json1).replace(/n/g, 'label'))
          const json3 = JSON.parse(JSON.stringify(json2).replace(/c/g, 'children'))
          json3.forEach(i => {
            i.children.forEach(j => {
              j.children.forEach(k => {
                delete k.children
              })
            })
          })
          this.options = json3
          // console.log(this.options)
        } else {
          this.$message.warning(res.msg)
        }
      },
      postOrderConfirm(cartId) {
        let that=this;
        var data = {
          cartId: cartId
        }
        //确认订单
        confirmOrder(data).then(res => {
          that.orderConfirmV2(res.data)
        })
      },

      orderConfirmV2(data){
        let that=this;
        data.cartInfo.forEach(element => {
          //element.productInfo.keyword = element.productInfo.keyword.split(';')
          that.totalNum = this.totalNum + element.cartNum
        });
        that.orderInfo = Object.assign(this.orderInfo, data);
        const orderInfo = that.orderInfo;
        //选择默认优惠券
        if (orderInfo.usableCoupon) {
          this.couponId = orderInfo.usableCoupon.id;
        }
        this.defaultAddress = data.addressInfo
        if (this.defaultAddress === null) {
          this.defaultAddress = this.addressList[0]
        }

        //计算价格
        this.orderComputedPrice(that.orderInfo.orderKey);
        //根据购物车获取优惠券
        this.getCouponByCart();
      },
      orderComputedPrice(orderKey) {
        let that=this;
        var data = {
          cardId:this.cardId,
          payType: "weixin",
          couponId: this.couponId
        }
        //如果用户选择了地址
        if (this.orderInfo.addressInfo) {
          data.addressId = this.orderInfo.addressInfo.id
        }
        //计算订单金额
        computedOrder(orderKey, data).then(res => {
          if (res.status === 200) {
            this.computedPriceInfo = res.data.result;
            // if(res.data.result.cartInfo){
            //   this.orderInfo.cartInfo=res.data.result.cartInfo
            // }
            this.showPage=true;
          } else {
            this.$message.warning(res.msg || '请刷新重试！')
          }
        }).catch(err => {
          console.log(err)
          this.$message.warning(err.msg || '请刷新重试！')
        }).finally(()=>{
          that.cartNumClick=false
        })
      },
      //根据订单获取满足订单的礼遇卡和优惠券
      getCouponByCart() {
        getCouponByCart(this.cartId).then(res => {
          let couponsList = res.data;
          couponsList.valid.forEach((item, index) => {
            if (this.couponId === item.id) {
              this.chooseCouponIndex = index;
            }
          })
          if(couponsList.valid.length>0){
            this.couponsList=couponsList;
          }else{
            this.couponsList.valid[0].promotionName="无可用优惠券";
          }
        }).catch(err => {
          this.$message.warning(err.msg || '请刷新重试！')
        })
      },

      //确认选中的优惠券
      chooseCoupon() {
        let that=this;
        //let coupon=this.couponsList.valid[this.chooseCouponIndex];
        //that.couponName = coupon.promotionName;
        //that.couponId = coupon.id;
        that.orderComputedPrice(this.orderInfo.orderKey)
      },
      // 提交订单
      submit () {
        this.btnLoading = true
        createOrder(this.orderInfo.orderKey, {
          addressId: this.addressList[this.addressIndex].id,
          bargainId: 0,
          combinationId: 0,
          couponId: this.couponId,
          from: 'pc',
          isChannel: '',
          mark: this.mark,
          payType: 'weixin',
          phone: '',
          pinkId: 0,
          realName: '',
          seckillId: 0,
          useIntegral: ''
        }).then(res => {
          if (res.status === 200) {
            res.data.result.price = this.computedPriceInfo.payPrice
            res.data.result.createTime = res.data.createTime
            this.$router.push({
              path: '/orders',
              query: res.data.result
            })
          } else {
            console.log(res)
            this.$message.warning(res.msg || '提交订单失败！')
          }
          this.btnLoading = false
        }).catch(err => {
          console.log(err)
          this.$message.warning(err.msg || '提交订单失败！')
          this.btnLoading = false
        })
      }
		},


	}
</script>

<style scoped lang="less">
	.address-bgs{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.address-bg{
			width: 49%;
			&.active{
				position: relative;
				border-color: #57ACA7;
				&:after{
					content: "";
					display: block;
					background: url(../assets/item-check.png) no-repeat;
					width: 25px;
					height: 25px;
					position: absolute;
					right: 0;
					top: 0;
				}
			}
		}
	}
	#cart-bar{
		height: auto;
	}
	.address-manage{
		width: 100%;
		min-height: 100px;
	}
	#cart-main .w90{
		width: 72px;
		text-align: center;
	}
	#cart-main .tool-bar .c2{
		width: 290px;
	}
	#cart-main .c22,
	#cart-main .c23
	{
		width: 100px;
	}
	#cart-main .c3{
		width: 150px;
	}
	#cart-main .c5{
		width: 100px;
	}
	#cart-main .c55{
		width: 200px;
	}
	.orderExtLeft{
		padding: 5px 0;
		.row
		{
			padding: 5px 0;
			.tit{
				width: 6em;
			}
			input{
				padding: 5px 10px;
				margin-right: 5px;
			}
			a{
				color: #57ACA7;
				&:hover{
					color: #57ACA7;
				}
			}
			select{
				padding: 5px 10px;
			}
		}
		textarea{
			border: 1px solid #DDDDDD;
			width: 300px;
			height: 50px;
			padding: 5px 10px;
			outline: none;
		}
	}
</style>
